import {
	GET_PORTER_QUOTE,
	GET_PORTER_QUOTE_LOADING,
	GET_PORTER_QUOTE_ERROR,
} from "./actionTypes";

const initialState = {
	loading: false,
	estimated_delivery_charge: null,
	currency: 'INR',
	error: null,
	message: null,
};

const porterQuoteReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PORTER_QUOTE_LOADING:
			return {
				...state,
				loading: action.payload,
			};
		case GET_PORTER_QUOTE:
			return {
				...state,
				estimated_delivery_charge: action.payload.estimated_delivery_charge,
				currency: action.payload.currency,
				error: null,
				message: null,
				loading: false,
			};
		case GET_PORTER_QUOTE_ERROR:
			return {
				...state,
				error: action.payload.error,
				message: action.payload.message,
				estimated_delivery_charge: null,
				loading: false,
			};
		default:
			return state;
	}
};

export default porterQuoteReducer;

